import { useForm } from "react-hook-form";
import { AddVendedorForm } from "../../vendedores/AddVendedorForm/components/AddVendedorForm";
import { useState } from "react";
import { VendedorInfo } from "src/types/vendedor";
import { VisitaRegister,  } from "../../../types/empresa";
import { useGetTurnosQuery } from "../../../api/filter/dataFilterApi";
import { ErrorMessage } from "../../../components/errors/ErrorMessage";
import { ActionButtons } from "src/components/ui/ActionButtons";
import { FormInput, FormSelect } from "src/components/ui/inputs";

interface Props {
    onAddVisit?: (data: VisitaRegister) => void;
    onCancel?: () => void;
    minAvailableDate?: string;
    maxAvailableDate?: string;
    errorMessage?: string | null;
    isLoading?: boolean;
}

export function RegisterVisitaForm({ onAddVisit, onCancel, minAvailableDate, maxAvailableDate, errorMessage, isLoading }: Props) {
    const { data: turnos } = useGetTurnosQuery();

    const [vendedoresAgregados, setVendedoresAgregados] = useState<VendedorInfo[]>([])

    const { 
        register,
        handleSubmit,
        formState: { errors }
    } = useForm<VisitaRegister>();

    const handleAddVisita = handleSubmit(async (data) => {
        if(!onAddVisit) return;

        data.vendedoresAsignados = vendedoresAgregados.map((vendedor) => vendedor.vendedorId);
        onAddVisit(data);
    })

    return (
        <div className="flex flex-col h-full overflow-auto">

            <div className="mt-2 flex-1 flex flex-col overflow-hidden">
                <p className="text-lg font-semibold">Nueva visita</p>

                <div className="flex gap-x-3 justify-between">
                    <div>
                        <FormInput
                            {...register("fecha", {
                                required: "La fecha de la visita es requerida",
                            })}
                            label="Fecha"
                            min={minAvailableDate}
                            max={maxAvailableDate}
                            aria-invalid={errors.fecha ? "true" : "false"}
                            type="date"/>

                        {errors.fecha?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.fecha?.message}</p>
                        )}
                    </div>


                    <div>
                        <FormInput
                            {...register("horaInicio", {
                                required: "La hora de inicio es requerida",
                                validate: {
                                    horaInicioIsBeforeFin: (horaInicio, formValues) => {
                                        // turno es Nocturno (id 3)
                                        if (formValues.turno == 3) return true;

                                        if(formValues.horaFin === undefined ||
                                            formValues.horaFin < horaInicio)
                                            return false;

                                        return true;
                                    }
                                },
                            })}
                            label="Hora de inicio"
                            aria-invalid={errors.horaInicio ? "true" : "false"}
                            type="time"/>

                        {errors.horaInicio?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.horaInicio?.message}</p>
                        )}
                        {errors.horaInicio?.type === "horaInicioIsBeforeFin" && (
                            <p className="valErrorText text-sm">La hora de inicio no puede ser mayor a la de fin</p>
                        )}
                    </div>

                    <div>
                        <FormInput
                            {...register("horaFin", {
                                required: "La hora de fin es requerida",
                                validate: {
                                    horaFinIsAfterInicio: (horaFin, formValues) => {
                                        // turno es Nocturno (id 3)
                                        if (formValues.turno == 3) return true;

                                        if(formValues.horaInicio === undefined ||
                                            horaFin < formValues.horaInicio)
                                            return false;

                                        return true;
                                    }
                                }
                            })}
                            label="Hora de fin"
                            aria-invalid={errors.horaFin ? "true" : "false"}
                            type="time"/>

                        {errors.horaFin?.type === "required" && (
                            <p className="valErrorText text-sm">{errors.horaFin?.message}</p>
                        )}
                        {errors.horaFin?.type === "horaFinIsAfterInicio" && (
                            <p className="valErrorText text-sm">La hora de fin no puede ser antes que la de inicio</p>
                        )}
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-x-2">
                    <div>
                        <FormSelect
                            {...register("turno", {
                                min: 1
                            })}
                            label="Turno"
                            aria-invalid={errors.turno ? "true" : "false"}
                            placeholder="Seleccionar turno"
                            options={turnos?.map((item) => ({ label: item.nombre, value: item.id})) ?? []}/>

                        {errors.turno?.type === "min" && (
                            <p className="valErrorText text-sm">{"El turno es requerido"}</p>
                        )}
                    </div>
                </div>

                <div className="overflow-hidden">
                    <AddVendedorForm 
                        setVendedoresAgregados={setVendedoresAgregados}
                        vendedoresAgregados={vendedoresAgregados}
                        dealId={0} />
                </div>
            </div>

            {errorMessage && (
                <div className="my-3">
                    <ErrorMessage>
                        {errorMessage}
                    </ErrorMessage>
                </div>
            )}

            <ActionButtons 
                isLoading={isLoading ?? false}
                saveButtonText="Agregar visita"
                saveButtonType="button"
                onSave={() => handleAddVisita()}
                onCancel={onCancel}/>
        </div>
    );
}
